/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateLocationRequest,
  CreateOrganization400Response,
} from '../models/index';
import {
    CreateLocationRequestFromJSON,
    CreateLocationRequestToJSON,
    CreateOrganization400ResponseFromJSON,
    CreateOrganization400ResponseToJSON,
} from '../models/index';

export interface CreateLocationOperationRequest {
    createLocationRequest: CreateLocationRequest;
}

/**
 * 
 */
export class LocationApi extends runtime.BaseAPI {

    /**
     */
    async createLocationRaw(requestParameters: CreateLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createLocationRequest'] == null) {
            throw new runtime.RequiredError(
                'createLocationRequest',
                'Required parameter "createLocationRequest" was null or undefined when calling createLocation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/locations/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLocationRequestToJSON(requestParameters['createLocationRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createLocation(requestParameters: CreateLocationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
